import React from "react";
import PropTypes from "prop-types";
import BondBillingInformationBase from "../../../../features/bonds/shared/components/BondBillingInformationBase";

/** Thin retrieval wrapper over BondBillingInformationBase (Phase 9.14C). */
const BondRetrievalBillingInformationBase = ({
  cfg,
  GoogleAutoComplete,
  LabeledCreatableSelect,
  globalData,
  data,
  updateData,
  isDisabled = false,
}) => (
  <BondBillingInformationBase
    cfg={cfg}
    GoogleAutoComplete={GoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    globalData={globalData}
    data={data}
    updateData={updateData}
    isDisabled={isDisabled}
  />
);

BondRetrievalBillingInformationBase.propTypes = {
  cfg: PropTypes.object.isRequired,
  GoogleAutoComplete: PropTypes.elementType.isRequired,
  LabeledCreatableSelect: PropTypes.elementType.isRequired,
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default BondRetrievalBillingInformationBase;
